'use client';

import { c as _c } from "react/compiler-runtime";
import ClockIcon from '@eversports/design-tokens/assets/icons/regular/clock.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Button from '@eversports/klimt-primitives/Button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuTrigger } from '@eversports/klimt-primitives/DropdownMenu';
import { useTranslations } from 'next-intl';
import formatTimeFilter from './helpers/format-time-filter';
import { ALL_TIME_FILTERS_VALUE } from './TimeFilter';
import { START_TIME_OPTIONS } from './TimeFilter.constants';
interface Props {
  selectedTime: string | null;
  updateFilter: (value: string) => void;
}
const TimeFilterDropdown = t0 => {
  const $ = _c(23);
  const {
    selectedTime,
    updateFilter
  } = t0;
  const t = useTranslations("discover-sport-city");
  const t1 = selectedTime ? "tertiary-selected" : "tertiary";
  const t2 = selectedTime ? "text-text-brand-primary" : "text-text-secondary";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("size-2", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t3) {
    t4 = <ClockIcon className={t3} aria-hidden={true} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== selectedTime || $[5] !== t) {
    t5 = selectedTime ? formatTimeFilter(selectedTime) : t("starting-time");
    $[4] = selectedTime;
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t1 || $[8] !== t4 || $[9] !== t5) {
    t6 = <DropdownMenuTrigger asChild={true} className="hidden items-center gap-1 sm:flex"><Button size="sm" variant={t1}>{t4}{t5}</Button></DropdownMenuTrigger>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = selectedTime ?? ALL_TIME_FILTERS_VALUE;
  let t8;
  if ($[11] !== t) {
    t8 = t("all-filters");
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8) {
    t9 = <DropdownMenuRadioItem variant="circular" value={ALL_TIME_FILTERS_VALUE}>{t8}</DropdownMenuRadioItem>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = START_TIME_OPTIONS.map(_temp);
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t7 || $[17] !== t9 || $[18] !== updateFilter) {
    t11 = <DropdownMenuPortal><DropdownMenuContent align="start" className="h-28 min-w-(--radix-dropdown-menu-trigger-width) overflow-y-scroll p-0"><DropdownMenuRadioGroup value={t7} onValueChange={updateFilter}>{t9}{t10}</DropdownMenuRadioGroup></DropdownMenuContent></DropdownMenuPortal>;
    $[16] = t7;
    $[17] = t9;
    $[18] = updateFilter;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t6) {
    t12 = <DropdownMenu>{t6}{t11}</DropdownMenu>;
    $[20] = t11;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
};
export default TimeFilterDropdown;
function _temp(option) {
  return <DropdownMenuRadioItem key={option} variant="circular" value={option.toString()}>{formatTimeFilter(option.toString())}</DropdownMenuRadioItem>;
}